import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import ProtectedManagementCompanySectionRoute from './ProtectedManagementCompanySectionRoute';
import { PRIVATE_PATH, PERMISSION } from '../constants';
import FlexProfessionals from '../features/flex-workers/professionals/FlexProfessionals';
import FlexProfessionalDetails from '../features/flex/professionals/FlexProfessionalDetails';
import ManagementCompanySettings from '../features/flex/settings/ManagementCompanySettings';

const ManagementCompanyRoutes = ({ userData, activeFacility }) => (
	<Switch>
		<ProtectedManagementCompanySectionRoute
			exact
			path={PRIVATE_PATH.WORKFORCE_PAGE}
			key={`workforce-${activeFacility}`}
			component={FlexProfessionals}
			pathPermission={PERMISSION.WORKFORCE_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			path="/private/workforce/:managementCompanyId/professionals/:caregiverId"
			key={`employee-details-${activeFacility}`}
			component={FlexProfessionalDetails}
			pathPermission={PERMISSION.WORKFORCE_PROFESSIONAL_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			exact
			path={PRIVATE_PATH.COMPANY_SETTINGS}
			key={`settings-default-${activeFacility}`}
			component={ManagementCompanySettings}
			pathPermission={PERMISSION.SETTINGS_PAGE_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			path={`${PRIVATE_PATH.COMPANY_SETTINGS}/:managementCompanyId`}
			key={`settings-${activeFacility}`}
			component={ManagementCompanySettings}
			pathPermission={PERMISSION.SETTINGS_PAGE_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<Redirect to="/404" />
	</Switch>
);

export default ManagementCompanyRoutes;
